import ArticleLayout from "../components/ArticleLayout";

export default function ShoesGuide() {
  return <ArticleLayout articleId={6} />;
}